let letras = ["A","B","C","E","F","G","H","I","J","K","L","M","N","Ñ","O","P","Q","R","S","T","U","V","W","X","Y","Z"];

let numeros = ["0","1","2","3","4","5","6","7","8","9"];

export {numeros, letras}